<div class="align-items-center flex justify-content-center lg:px-8 md:px-6 px-4 py-8 surface-ground">
    <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
        <div class="text-center mb-5">
            <img src="assets/images/blocks/logos/hyper.svg" alt="Image" height="50" class="mb-3">
            <div class="text-900 text-3xl font-medium mb-3">Signing out</div>
            <span class="text-600 font-medium line-height-3">Please Wait</span>
        </div>
    </div>
</div>